<template>
    <div>

        <LoadingSubmitSpot v-if="processingRequest"></LoadingSubmitSpot>

        <div class="spot-search-wrap">

            <!-- Search Input -->
            <div class="spot-search">
                <button type="button" role="button">
                    <svg class="search"><use xlink:href="#search"></use></svg>
                </button>
                <input type="text"
                       style="outline: none;"
                       id="autocomplete-address"
                       autofocus
                       placeholder="Enter name of spot to start">
            </div>

            <!-- Show Spot Result -->
            <div class="spot-search-final">
                <div class="spot-search-final-inner" v-if="currentPlace">
                    <div class="img-wrap" v-if="currentPlace.photos && currentPlace.photos.length">
                        <img class="spot-image" :src="currentPlace.photos[0].getUrl()">
                    </div>
                    <div class="content">
                        <h4 v-text="currentPlace.name"></h4>
                        <p>
                            <span v-html="currentPlace.adr_address"></span>
                            <span v-if="currentPlace.international_phone_number"
                                  v-text="currentPlace.international_phone_number">
                            </span>
                            <span class="exists-tooltip" v-if="isSubmitted && isPublished">
                            Good News! This spot already exists.
                            <a :href="spotUrl" target="_blank">Click here</a> to check it out or leave a review.
                        </span>
                            <span class="exists-tooltip" v-if="isSubmitted && !isPublished">
                            Good News! This spot already exists. It'll go live when the destination is launched on WT. Until then, <a href="/" target="_blank">keep exploring</a> all of the featured destinations!
                        </span>
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <!-- Show Form if the Spot haven't been Submitted/Suggested -->
        <form class="form suggest-spot-form suggest-spot-form-updated"
              action="/add-a-spot"
              method="POST"
              @submit.prevent="submit"
              enctype="multipart/form-data">

            <section>

                <!-- Select Destination -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="city_id">Destination*</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field form__field--select destinations-input">
                            <select @change="selectedDestination($event)" id="city_id" name="city_id" class="required" v-model="form.city_id">
                                <option  :value="null" disabled>Where's this spot located?</option>
                                <option v-for="city in cities" :value="city.id" v-text="city.title"></option>
                                <option value="other">Other</option>
                            </select>
                            <span class="error" v-if="form.errors.city_id" v-text="form.errors.city_id"></span>
                        </div>
                        <div class="form__field destination-other-input-wrap hide-me">
                            <input type="text" class="destination-other-input"
                                   v-model="form.other_destination_text"
                                   id="other-destination"
                                   name="other-destination"
                                   placeholder="Other Destination (required)">
                            <span class="error" v-if="form.errors.other_destination_text" v-text="form.errors.other_destination_text"></span>
                        </div>
                    </div>
                </div>

                <!-- Select Category -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="category_id">Category*</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field form__field--select ">
                            <select id="category_id" name="category_id" class="required" v-model="form.category_id">
                                <option :value="null" disabled>Somewhere to eat, sleep or play</option>
                                <option v-for="category in categories" :value="category.value" v-text="category.text"></option>
                            </select>
                            <span class="error" v-if="form.errors.category_id" v-text="form.errors.category_id"></span>
                        </div>
                    </div>
                </div>

                <!-- Review -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="notes">
                            Share your review
                            <small>Give us the deets</small>
                        </label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <textarea placeholder="Tell us why you love this spot and what makes it so great. Your feedback will show up as a review on the spot."
                                      name="notes"
                                      v-model="form.comments"
                                      id="notes"
                                      rows="4">
                            </textarea>
                        </div>
                    </div>
                </div>

                <!-- Images -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="images">Submit Images<small>Your personal Images</small></label>
                    </div>
                    <div class="form__row__right">
                        <UploadPhotos v-model="form.images" @uploadImagesStatus="isUploadingImages = $event"></UploadPhotos>
                    </div>
                </div>

                <!-- Add to a List -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="category_id">Add to a List<small>Save to your favorites</small></label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field form__field--select ">
                            <select id="list" name="list_id" v-model="form.list_id">
                                <option :value="null" selected>Select from your lists</option>
                                <optgroup label="Most Recent" v-if="mostRecentLists.length > 0">
                                    <option v-for="list in mostRecentLists" :key="list.id" :value="list.id" v-text="list.name"></option>
                                </optgroup>
                                <optgroup label="All" v-if="allLists.length > 0">
                                    <option v-for="list in allLists" :key="list.id" :value="list.id" v-text="list.name"></option>
                                </optgroup>
                            </select>
                            <span class="error" v-if="form.errors.list_id" v-text="form.errors.list_id"></span>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form__button">

                    <button type="submit" class="button" :class="{'disabled' : isDisabled }" :disabled="(form.isSubmitted || isUploadingImages)">
                        {{ form.isSubmitted ? 'Submitting Your Spot' : 'Submit Spot'}}
                        <svg class="arrow-right-2">
                            <use xlink:href="#arrow-right-2"></use>
                        </svg>
                    </button>
                </div>

            </section>
        </form>

    </div>
</template>
<script>

import Alert from '@/classes/Alert';
import LoadingSubmitSpot from './LoadingSubmitSpot';
import Form from '@/classes/Form';
import Helpers from '@/mixins/Helpers';
import UploadPhotos from '@/components/FormDropzone';
import AutoCompleteAddress from '@/mixins/GooglePlaces';
import AddToListResources from '@/mixins/AddToListResources'

export default {

    mixins:[Helpers, AutoCompleteAddress, AddToListResources],

    components: {
        UploadPhotos,
        LoadingSubmitSpot
    },

    data() {
        return {
            lists: [],
            cities: [],
            categories: [
                {value: 1, text: 'Eat (Restaurant)'},
                {value: 2, text: 'Sleep (Hotel or Airbnb)'},
                {value: 3, text: 'Play (Bar, attraction, activity etc)'},
            ],
            addressParts: {
                street_number: {
                    key: 'short_name',
                    to: 'address_line_1',
                    join: ''
                },
                route: {
                    key: 'long_name',
                    to: 'address_line_1',
                    join: ' '
                },
                locality: {
                    key: 'long_name',
                    to: 'city',
                    join: ''
                },
                neighborhood: {
                    key: 'long_name',
                    to: 'state',
                    join: ''
                },
                administrative_area_level_1: {
                    key: 'short_name',
                    to: 'state',
                    join : ''
                },
                country: {
                    key: 'long_name',
                    to: 'country',
                    join: ''
                },
                postal_code: {
                    key: 'short_name',
                    to: 'postal_code',
                    join: ''
                },
            },
            isPublished: false,
            isSubmitted: false,
            spotUrl: null,
            currentPlace: null,
            isUploadingImages: false,
            processingRequest: false,
            form: new Form({
                // Required
                title: '',
                google_place_id: null,
                city_id: null,
                other_destination_text: '',
                category_id: null,
                comments: '',
                images: [],
                list_id: null,
                // Optional
                address_line_1: '',
                state: '',
                city: '',
                postal_code: '',
                country: '',
                latitude: '',
                longitude: '',
                google_images: [],
                google_place_data: {
                    rating: 0,
                    formatted_address: '',
                },
                web: '',
                phone: '',
                // Extra
                place: null,
            }),
            placeOptions: {
                types: ['establishment'],
            },
            filterFields: null,
        }
    },

    created() {
        this.fetchResources()
    },

    methods: {

        placeChanged() {
            var place = this.autocomplete.getPlace()

            if (!place) {
                return
            }
            $('.spot-search-final').slideUp();
            $('.suggest-spot-form-updated').hide();
            this.verifySpot(place)
        },

        verifySpot(place) {

            if (!place || !place.place_id) {
                return
            }

            axios.get(`/suggest-spot-check/${place.place_id}`)
                .then(response => {

                    this.spotUrl = response.data.spot_url;
                    this.isSubmitted = !response.data.is_free
                    this.isPublished = !response.data.is_published
                    this.currentPlace = place
                    this.setAddressFromPlace()
                    $('.spot-search-final').slideDown();
                    if (this.isSubmitted) {
                        return;
                    }
                    this.fillFormData()
                })
                .catch(errors => {
                    // console.log(errors)
                })
        },

        fillFormData() {
            // console.log(this.currentPlace)
            this.form.google_place_id = this.currentPlace.place_id
            this.form.title = this.currentPlace.name
            // Website
            if (this.currentPlace.website) {
                this.form.web = this.currentPlace.website
            }
            // Phone
            if (this.currentPlace.international_phone_number) {
                this.form.phone = this.currentPlace.international_phone_number
            }
            // Lat and Lng
            if (this.currentPlace.geometry && this.currentPlace.geometry.location) {
                if (this.currentPlace.geometry.location.lat()) {
                    this.form.latitude = this.currentPlace.geometry.location.lat()
                }
                if (this.currentPlace.geometry.location.lng()) {
                    this.form.longitude = this.currentPlace.geometry.location.lng()
                }
            }
            this.form.google_images = _.map(this.currentPlace.photos, image => {
                return {
                    url: image.getUrl()
                }
            })
            if (this.currentPlace.rating) {
                this.form.google_place_data = {
                    rating: this.currentPlace.rating,
                    formatted_address: this.currentPlace.formatted_address
                }
            }

            $('.spot-search-final').slideDown(function () {
                $('.suggest-spot-form-updated').fadeIn();
            });
        },

        setAddressFromPlace() {
            for (var key in this.addressParts) {
                this.form[this.addressParts[key].to] = '';
            }
            for (var i = 0; i < this.currentPlace.address_components.length; i++) {
                var addressType = this.currentPlace.address_components[i].types[0];
                if (addressType != 'administrative_area_level_1' && addressType != 'neighborhood') {
                    if (this.addressParts[addressType]) {
                        var val = (this.addressParts[addressType].join + this.currentPlace.address_components[i][this.addressParts[addressType].key]);
                        this.form[this.addressParts[addressType].to] += val;
                    }
                } else {
                    this.form[this.addressParts[addressType].to] = this.currentPlace.address_components[i][this.addressParts[addressType].key];
                }
            }
        },

        selectedDestination(event) {
            var $hiddenEl = $('.destination-other-input-wrap')
            var $hiddenInput = $('.destination-other-input')

            if (this.form.city_id == 'other') {
                $hiddenEl.slideDown()
                $hiddenInput.focus();
            } else {
                $hiddenEl.slideUp();
            }
        },

        fetchResources() {
            // Fetch authe user lists.
            axios.get(`/user/lists`)
                .then(response => {
                    this.lists = _.filter(response.data.lists, list => {
                        return list.user_id == config.user.id
                    })
                })

            // Fetch current destinations
            axios.get(`/destinations-all`)
                .then(response => {
                    this.cities = response.data.cities
                })
        },

        submit() {
            this.processingRequest = true
            this.form.post(`/add-a-spot`)
                .then(response => {
                    if (response.published) {
                        eventBus.$emit('reset-form-dropzone')
                        this.redirectTo(response.url)
                    }
                    this.redirectTo(response.url)
                })
                .catch(errors => {
                    // console.log(errors.message)
                    this.processingRequest = false
                    Alert.error(errors.message)
                })
        },

        createdField() {
            setTimeout(function(){
                $('.pac-container').insertAfter('.spot-search');
            }, 300);

            $('#autocomplete-address').on('keydown input change', function () {
                $('.spot-search-wrap').addClass('w-results');
                $('.spot-search-final').slideUp(function () {
                    $('.spot-search-final .spot-image').attr("src", "");
                });
                $('.suggest-spot-form-updated').fadeOut();
                if ($(this).val() != '') {
                    $('.pac-container').css('height', $('.pac-container')[0].scrollHeight + 'px');
                } else {
                    $('.pac-container').css('height', '0px');
                }
            })
        },
    },

    computed: {
        isDisabled() {
            if (this.form.isSubmitted) {
                return true;
            }
            if(this.isUploadingImages){
                return true
            }
            if (this.form.category_id == null) {
                return true;
            }
            // if (this.form.comments.trim() == '') {
            //     return true;
            // }
            if (this.form.city_id == null) {
                return true;
            }
            if (this.form.city_id == 'other') {
                if (this.form.other_destination_text.trim() == '') {
                    return true;
                }
            }
            return false;
        }
    }
}
</script>
